<template>
   <div class="conclusion">
      <div class="image-container">
         <img :src="diamondSrc" alt="">
      </div>
      <div class="text">
         <p class="knockout-lite">
            <span v-html="article.conclusion.text"></span>
         </p>
      </div>
   </div>
</template>

<script>

    export default {
        name: 'ConclusionSection',
        props: [
            'article'
        ],
        data() {
            return {}
        },
        computed: {
            diamondSrc() {
                return require('./../assets/images/' + this.article.conclusion.image)
            }
        }
    }
</script>

<style lang="scss">

   @import '../scss/the-goods';

   $articlesNum : 5;

   #section-6 {

      .portrait-mode & {
         @include screen-md-lg-xl {
            height : 100vh;
         }
      }

      .conclusion-mask {
         width         : 42vw;
         height        : 80vh;
         position      : relative;
         margin-bottom : 5vh;

         @include screen-xs-sm {
            width         : 100vw;
            margin-bottom : 15vh;
         }

         @media screen and (max-height : 720px) and (min-width : $screen-md-min) {
            height : 85vh;
         }

         .landscape-mode & {
            @include screen-xs-sm {
               display : flex;
            }
         }

         .portrait-mode & {
            @include screen-md-lg-xl {
               width       : 65vw;
               display     : flex;
               align-items : center;
            }
         }

         .conclusion {
            width      : 100%;
            height     : 100%;
            position   : absolute;
            top        : 0;
            left       : 0;
            opacity    : 0;
            visibility : hidden;

            .landscape-mode & {
               @include screen-xs-sm {
                  position : fixed;
                  height   : 100vh;
                  width    : calc(60% + 1px);
                  top      : 0;
                  left     : 0;
                  overflow : hidden;

                  .text {
                     padding : 0 0 0 12vw;
                  }
               }
            }

            .text,
            .image-container {
               position    : absolute;
               width       : 100%;
               height      : 100%;
               display     : flex;
               align-items : center;
            }

            .image-container {
               justify-content : center;
               overflow        : hidden;

               img {
                  max-width  : 42vw;
                  max-height : 75vh;
                  opacity    : 0;
                  transform  : translateY(100%);

                  .portrait-mode & {
                     @include screen-xs-sm {
                        max-width : 92vw;
                     }

                     @include screen-md-lg-xl {
                        max-width : 65vw;
                     }
                  }

               }
            }

            .text {
               @include screen-xs-sm {
                  padding : 0 10vw;
               }

               p {
                  color          : #fff;
                  font-size      : 5.7em;
                  line-height    : .9em;
                  margin         : 0px;
                  overflow       : hidden;
                  letter-spacing : 0.4rem;

                  @include screen-md-lg-xl {
                     font-size : 4.5em;
                  }

                  .landscape-mode & {

                     @media screen and (max-height : 680px) and (min-width : $screen-md-min) {
                        font-size : 3.5em;
                     }

                     @media screen and (max-height : 580px) and (min-width : $screen-md-min) {
                        font-size : 3em;
                     }
                  }

                  @include screen-xs-sm {
                     font-size : 3em;
                  }

                  span {
                     transform   : translateY(-100%);
                     display     : block;
                     transition  : transform .6s;
                     white-space : normal;
                  }
               }
            }
         }
      }

      @for $i from 1 through $articlesNum {

         &.active-#{$i} {
            .conclusion:nth-child(#{$i}) {
               opacity    : 1;
               visibility : visible;

               .image-container {

                  img {
                     opacity    : 1;
                     transform  : translateY(0%);
                     transition : transform $default-bez .6s;
                  }
               }

               .text {
                  span {
                     transform  : translateY(0%);
                     transition : transform $default-bez .6s;
                  }
               }
            }
         }

         &.out-#{$i} {
            .conclusion:nth-child(#{$i}) {
               opacity    : 1;
               visibility : visible;

               .image-container {
                  img {
                     opacity    : 0;
                     transform  : translateY(-100%);
                     transition : transform $default-bez .6s, opacity .3s;
                  }
               }

               .text {
                  span {
                     transform  : translateY(100%);
                     transition : transform $default-bez .6s;
                  }
               }
            }
         }
      }
   }

</style>



// WEBPACK FOOTER //
// src/components/ConclusionSection.vue